// Whether the app is being served from the dev portal (or a local dev server), which decides if
// test-only data such as the "Testing" clinic is shown. Any other host, production included,
// counts as production, so an unknown or mistyped host never exposes test data to members.
const DEV_HOSTNAMES = ['portal-dev.toothlens.com', 'localhost'];

export const isDevPortal = (hostname = window.location.hostname) => DEV_HOSTNAMES.includes(hostname);
